import { render, staticRenderFns } from "./VideoCallContainer.vue?vue&type=template&id=f88aecb6&scoped=true&"
import script from "./VideoCallContainer.vue?vue&type=script&lang=ts&"
export * from "./VideoCallContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f88aecb6",
  null
  
)

export default component.exports